import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgYearInReviewLogoFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewLogoFull";
import { SvgYearInReviewTextFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewTextFull";
import { AppRoutes, getProfileOverviewUrl } from "@ugg/shared/routes/app-routes";
import { Link, useParams } from "react-router-dom";

export const YearInReviewUnavailable = () => {
  const { region, riotUserName, riotTagLine } = useParams<{ riotUserName: string; riotTagLine: string; region: string }>();
  return (
    <div className="flex flex-col items-center gap-[24px]">
      <div className="flex space-x-[19px] justify-center">
        <Icon icon={<SvgYearInReviewLogoFull />} className="w-[104.273px] h-[100px]" />
        <div className="flex flex-col space-y-[20px]">
          <Icon icon={<SvgYearInReviewTextFull />} className="w-[156.779px] h-[76.266px]" />
          <div className="w-[154.933px] h-[3.35px] bg-[#D3A752] drop-shadow-[0_2px_2px_rgba(0,0,0,0.25)] border-0" />
        </div>
      </div>
      <h1 className="text-center text-[48px] font-semibold uppercase leading-normal tracking-normal drop-shadow-[0_2px_2px_rgba(0,0,0,0.40)] font-[Barlow] bg-gradient-to-b from-[#F4C874_25%] to-[#D3A752_84%] bg-clip-text text-transparent pt-[24px]">
        Unavailable
      </h1>
      <p className="text-center text-sm font-normal leading-normal text-[#CDDCFE] font-inter">
        This summoner hasn't generated their Year In Review yet.
      </p>
      <div className="flex gap-x-[12px] text-white text-[13px] font-bold">
        <Link
          to={AppRoutes.YEAR_IN_REVIEW}
          className="flex items-center justify-center min-w-[145px] rounded-[3px] bg-[#3273FA] px-[12px] py-[10px] shadow-[0_2px_2px_0_rgba(0,0,0,0.25)] transition-all duration-200 hover:brightness-125"
        >
          Generate Your Own
        </Link>
        <Link
          to={getProfileOverviewUrl(region, riotUserName, riotTagLine)}
          className="flex justify-center min-w-[120px] px-[12px] py-[10px] rounded-[3px] bg-[#313160] shadow-[0_2px_2px_0_rgba(0,0,0,0.25)]"
        >
          Go Back
        </Link>
      </div>
    </div>
  );
};
